// Set up all fields and multiple validators for each
import React, { useEffect } from "react";
import * as yup from "yup";
import { useField } from "formik";

import { DatePicker } from "@mui/x-date-pickers";

import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";

export const initial = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, null> => ({
  [keyFromIdentity(question.identity, parent, index)]: null,
});

export const validator = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const key = keyFromIdentity(question.identity, parent, index);
  // DatePicker and unmarshal(FormAnswerDate) use JavaScript Date, not strings.
  const value = yup.date().typeError("Invalid date format").nullable();
  return {
    [key]: question.required ? value.required() : value,
  };
};

const DatePickerField = (props: any): React.ReactElement => {
  const [field, meta, helpers] = useField(props);
  const { name, value } = field;
  const { touched, error } = meta;
  const { setValue, setTouched } = helpers;
  // Validate on transition:
  useEffect(() => () => {
    helpers.setTouched(true);
  }, []);

  return (
    <>
      <DatePicker
        slotProps={{
          textField: {
            fullWidth: true,
            style: { minWidth: "15em" },
            error: meta.touched && !!meta.error,
            margin: "dense",
            name,
            autoComplete: "off",
            variant: "outlined",
            required: props.required,
            label: props.title,
            placeholder: "01/22/2020",
            InputLabelProps: { shrink: true },
            helperText: touched && error ? error : "",
          },
          inputAdornment: { position: "end" },
        }}
        disableFuture={props.name.includes("dob") || props.name.includes("birth") || props.disableFuture}
        closeOnSelect
        format="MM/dd/yyyy"
        value={value}
        onOpen={() => setTouched(true)}
        onChange={(date: Date | null) => {
          if (date === null || (date instanceof Date && !isNaN(date.getTime()))) {
            setValue(date);
            setTouched(true);
          }
        }}
        disabled={!!props.disabled}
      />
    </>
  );
};
DatePickerField.validator = validator;
DatePickerField.initial = initial;

export default DatePickerField;
